import { useEffect, useState } from 'react';
import { TIMEOUT_BEFORE_ERROR_S } from '@feature/payment/solidgate/config/solidgate.form.config';
import { useSolidgateModals } from '@feature/payment/solidgate/hooks/useSolidgateModals';

export const useSolidgateErrorCountdown = (isFormReady: { isFormReady: boolean }) => {
  const [, setCountdown] = useState(TIMEOUT_BEFORE_ERROR_S); // Countdown for payment status check to display error message
  const { paymentStatusModal, paymentModal } = useSolidgateModals();

  const resetCountdown = () => setCountdown(TIMEOUT_BEFORE_ERROR_S);

  useEffect(() => {
    if (isFormReady) return;
    // Start countdown for payment status check
    const interval = setInterval(() => {
      if (isFormReady) {
        clearInterval(interval);
        return; // Stop countdown without error if form is ready
      }
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          paymentModal.close(); // cancel loading payment form
          paymentStatusModal.error(); // show "unknown error" message
          return 0; // Stop countdown at 0
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [paymentModal, isFormReady, paymentStatusModal]);

  return { resetCountdown };
};
